import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, DatePicker, Input, Tooltip, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import { Row, Form, Col, Select, Collapse } from "antd";
import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { InfoCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import CleaningTraceabilityApi from "../common/Apis/CleaningTraceabilityApi";
import { color } from "d3";
import AddNodeModel from "../common/Models/AddNodeModel/AddNodeModel";
const CleaningTraceability = () => {
    const [weekDates, setWeekDates] = useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const navigate = useNavigate();
    const { Content } = Layout;
    const { Panel } = Collapse;
    const [Traceability, setTraceability] = React.useState([]);
    const [FilterTpe, setFilterTpe] = React.useState();
    const getCleaningTraceability = useCallback(() => {
        CleaningTraceabilityApi.ListcleaningTraceabilityAssign().then((response) => {
            setTraceability(response.payloadDto)
        })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const [TraceabilityDaily, setTraceabilityDaily] = React.useState([]);
    const getCleaningTraceabilityDaily = useCallback(() => {
        CleaningTraceabilityApi.ListCleaningTraceabilityCommon('daily').then((response) => {
            setTraceabilityDaily(response.payloadDto)
        })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const [TraceabilityMonthly, setTraceabilityMonthly] = React.useState([]);
    const getCleaningTraceabilityMonthly = useCallback(() => {
        CleaningTraceabilityApi.ListCleaningTraceabilityCommon('monthly').then((response) => {
            setTraceabilityMonthly(response.payloadDto)
        })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const [Traceabilityweekly, setTraceabilityweekly] = React.useState([]);
    const getCleaningTraceabilityweekly = useCallback(() => {
        CleaningTraceabilityApi.ListCleaningTraceabilityCommon('weekly').then((response) => {
            setTraceabilityweekly(response.payloadDto)
        })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);
    const getCurrentWeekDates = () => {
        const today = moment();
        const currentDay = today.day();
        const daysToSubtract = currentDay === 0 ? 6 : currentDay - 1;
        const startDate = moment(today).subtract(daysToSubtract, 'days');
        const weekDates = [];

        for (let i = 0; i < 7; i++) {
            const date = moment(startDate).add(i, 'days');
            weekDates.push(date);
        }
        setWeekDates(weekDates);
    };
    const formatDateAsMMDD = (date2) => {

        const date = new Date(date2);
        const options = { weekday: 'long' };
        const dayName = date.toLocaleDateString(undefined, options);
        const firstLetter = dayName.charAt(0);
        const Letter = date2.format('DD/MM/YY');
        return `${Letter}  (${firstLetter})`;
    };
    const currentDate = moment().format("DD/MM/YYYY");

    const formatDateAsMMDD2 = (date2) => {

        const date = new Date(date2);
        const filteredItems = Traceability.filter(item => {
            const itemCreateDate = new Date(item.cleaningTraceabilityAddDate);
            const itemCreateDate1 = itemCreateDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
            const date22 = dayjs(date2).format("DD/MM/YYYY");

            return itemCreateDate1 === date22;
        });


        return filteredItems;
    };
    useEffect(() => {
        getCleaningTraceability();
        PageLoading();
        getCleaningTraceabilityweekly();
        getCleaningTraceabilityDaily();
        getCleaningTraceabilityMonthly();
        getCurrentWeekDates();
    }, [getCleaningTraceability, PageLoading, getCleaningTraceabilityweekly, getCleaningTraceabilityDaily, getCleaningTraceabilityMonthly]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);


    const handleClear = () => {
        getCleaningTraceability();
        getCurrentWeekDates();
        setIsLoading(true);
        setFilterTpe(null);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterRecipe([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };
    const formRef = useRef(null);

    const [filterRecipe, setFilterRecipe] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);


    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    const handleSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        const startDate1 = dayjs(data.DateRang1).format("YYYY-MM-DD");
        const endDate1 = dayjs(data.DateRang2).format("YYYY-MM-DD");

        const startDate = moment(startDate1);
        const endDate = moment(endDate1);

        const allDates = [];
        let currentDate = startDate.clone();

        while (currentDate.isSameOrBefore(endDate)) {
            allDates.push(moment(currentDate));
            currentDate.add(1, 'days');
        }

        console.log(allDates);
        setWeekDates(allDates);
        if (data.SelectType === 'any') {
            setFilterTpe(null);
        } else {
            setFilterTpe(data.SelectType);
        }
    };
    const [FilterName, setFilterName] = useState(false);
    const handleChangeAnswertype = (value) => {
        setFilterName(value);
    };


    const paginatedData = Traceability.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const [modalNodeModeVisible, setNodeMode] = useState(false);
    const [NodeModeDatas, setNodeModeDatas] = useState(false);
    const addNodeMode = (nodeDetails) => {
        setNodeMode(true);
        setNodeModeDatas(nodeDetails)

    };
    const handlNodeModeCloseModal = () => {
        setNodeMode(false);
    };
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase();
    }
    const getNotes = (nodeDetails) => {
        if (nodeDetails?.traceabilityType === 'daily') {
            const tot = TraceabilityDaily.filter(item => item?.cleaningTraceabilityDate === nodeDetails?.id);
            if (tot?.length === 0) {
                // return <PlusCircleFilled className="PlusAddIcon" onClick={() => addNodeMode(nodeDetails)} />;
            } else {
                return <Tooltip placement="top" title={(
                    <div>
                        <div >{tot[0]?.managerNote}</div>
                    </div>
                )}>
                    <InfoCircleFilled className="PlusAddIcon" />
                </Tooltip>;

            }
        } else if (nodeDetails?.traceabilityType === 'monthly') {
            const tot = TraceabilityMonthly.filter(item => item?.cleaningTraceabilityDate === nodeDetails?.id);
            if (tot?.length === 0) {
                // return <PlusCircleFilled className="PlusAddIcon" onClick={() => addNodeMode(nodeDetails)} />;
            } else {
                return <Tooltip placement="top" title={(
                    <div>
                        <div >{tot[0]?.managerNote}</div>
                    </div>
                )}>
                    <InfoCircleFilled className="PlusAddIcon" />
                </Tooltip>;

            }
            console.log(TraceabilityMonthly.filter(item => item?.cleaningTraceabilityDate === nodeDetails?.id))
        } else {
            const tot = Traceabilityweekly.filter(item => item?.cleaningTraceabilityDate === nodeDetails?.id);
            if (tot?.length === 0) {
                // return <PlusCircleFilled className="PlusAddIcon" onClick={() => addNodeMode(nodeDetails)} />;
            } else {
                return <Tooltip placement="top" title={(
                    <div>
                        <div >{tot[0]?.managerNote}</div>
                    </div>
                )}>
                    <InfoCircleFilled className="PlusAddIcon" />
                </Tooltip>;

            }
        }

    }

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterRecipe.map((input, filterProductionIndex) => (
                                        <div key={filterProductionIndex}>
                                            <Row gutter={24} className="pt-2">


                                                <Col lg={4} md={4} className="px-1">
                                                    <Form.Item
                                                        name="SelectType"
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            onChange={(value) =>
                                                                handleChangeAnswertype(
                                                                    value
                                                                )
                                                            }
                                                            options={[

                                                                {
                                                                    value: "any",
                                                                    label: "Any",
                                                                },
                                                                {
                                                                    value: "daily",
                                                                    label: "Daily",
                                                                },
                                                                {
                                                                    value: "weekly",
                                                                    label: "Weekly",
                                                                },
                                                                {
                                                                    value: "monthly",
                                                                    label: "Monthly",
                                                                },
                                                                {
                                                                    value: "assigneeEmail",
                                                                    label: "Assignee Email",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>


                                                <Col lg={4} md={4} className="px-1">
                                                    {FilterName !==
                                                        "assigneeEmail" ? (
                                                        <>
                                                            <Form.Item
                                                                name="DateRang1"
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select End Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <DatePicker
                                                                    format={"DD/MM/YYYY"}
                                                                    placeholder="Select Start Date"
                                                                    className="form-control control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name={`type${filterProductionIndex}`}
                                                                className="text-lable"
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    placeholder="Condition"

                                                                    options={[
                                                                        { value: "%", label: "Matches with" },
                                                                        {
                                                                            value: "=",
                                                                            label: "Equals to",
                                                                        },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>

                                                <Col lg={4} md={4} className="px-1">
                                                    {FilterName !==
                                                        "assigneeEmail" ? (
                                                        <>
                                                            <Form.Item
                                                                name="DateRang2"
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select End Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <DatePicker
                                                                    format={"DD/MM/YYYY"}
                                                                    placeholder="Select End Date"
                                                                    className="form-control control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name="FilterAssingm"
                                                                className="text-lable"
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>




                                                <Col lg={8} md={10} className="px-1">
                                                    <Form.Item className="text-lable">
                                                        <Row gutter={23} className="mb-3">


                                                            <Col span={10}>
                                                                <Button
                                                                    type="primary"
                                                                    htmlType="submit"
                                                                    className="btn btn-primary btn-save table-action icon-center "
                                                                >
                                                                    Filter
                                                                </Button>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Button
                                                                    type="reset"
                                                                    htmlType="reset"
                                                                    onClick={() => handleClear()}
                                                                    style={{ color: "#0b5ed7" }}
                                                                    className="btn btn-primary btn-back table-action icon-center"
                                                                >
                                                                    Clear
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        {/* <Link
                            className={decodedToken?.permissions?.some(
                                (permission) => permission?.authority === 'VIEW_CLEANING_TRACEABILITY_DAILY'
                            ) ? 'btn btn-primary btn-save m-2' : 'd-none'}
                            to={'/daily-cleaning-traceability'}
                        >
                            Daily Cleaning
                        </Link> */}
                        <Space>
                            <Link to={"/daily-cleaning-traceability"}>
                                <Button
                                    type="primary"
                                    style={{
                                        display: decodedToken?.permissions?.some(
                                            (permission) => permission?.authority === "VIEW_CLEANING_TRACEABILITY_DAILY"
                                        )
                                            ? "block"
                                            : "none",
                                        height: "auto",
                                        lineHeight: "normal",
                                        alignItems: "center",
                                        padding: "5px 24px",
                                    }}
                                >
                                    Daily Cleaning
                                </Button>
                            </Link>
                            {/* <Link
                            className={decodedToken?.permissions?.some(
                                (permission) => permission?.authority === 'VIEW_CLEANING_TRACEABILITY_WEEKLY'
                            ) ? 'btn btn-primary btn-save m-2' : 'd-none'}
                            to={'/weekly-cleaning-traceability'}
                        >
                            Weekly Cleaning
                        </Link> */}
                            <Link to={"/weekly-cleaning-traceability"}>
                                <Button
                                    type="primary"
                                    style={{
                                        display: decodedToken?.permissions?.some(
                                            (permission) => permission?.authority === "VIEW_CLEANING_TRACEABILITY_WEEKLY"
                                        )
                                            ? "block"
                                            : "none",
                                        height: "auto",
                                        lineHeight: "normal",
                                        alignItems: "center",
                                        padding: "5px 24px",
                                    }}
                                >
                                    Weekly Cleaning
                                </Button>
                            </Link>
                            {/* <Link
                            className={decodedToken?.permissions?.some(
                                (permission) => permission?.authority === 'VIEW_CLEANING_TRACEABILITY_MONTHLY'
                            ) ? 'btn btn-primary btn-save m-2' : 'd-none'}
                            to={'/monthly-cleaning-traceability'}
                            style={{ width: '22%' }}
                        >
                            Monthly Cleaning
                        </Link> */}
                            <Link to={"/monthly-cleaning-traceability"}>
                                <Button
                                    type="primary"
                                    style={{
                                        display: decodedToken?.permissions?.some(
                                            (permission) => permission?.authority === "VIEW_CLEANING_TRACEABILITY_MONTHLY"
                                        )
                                            ? "block"
                                            : "none",
                                        height: "auto",
                                        lineHeight: "normal",
                                        alignItems: "center",
                                        padding: "5px 24px",
                                    }}
                                >
                                    Monthly Cleaning
                                </Button>
                            </Link>
                        </Space>
                        <div className="dateFilterTable">
                            <table className="table users-table">
                                <thead>
                                    <tr>
                                        {weekDates.map((date, index) => (
                                            <th key={index} className="text-center">{formatDateAsMMDD(date)}</th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        {weekDates.map((date, index) => (
                                            <>
                                                <td key={index} className="CleanTable" style={{ width: '14%' }}>
                                                    <>
                                                        {FilterTpe && <>
                                                            {formatDateAsMMDD2(date)?.filter(dateaa => dateaa.traceabilityType === FilterTpe).map((date2, index2) => (
                                                                <div className="trNew" style={{
                                                                    color: date2?.modifiedDate ? 'green' :
                                                                        date2?.cleaningTraceabilityAddDate && date2?.cleaningTraceabilityAddDate >= convertToUnixTimestamp(currentDate) ? 'black' :
                                                                            'red'
                                                                }}>{date2?.cleaningTraceabilityItemDTO?.traceabilityName} [{date2?.traceabilityName}] ({capitalizeFirstLetter(date2?.traceabilityType)})</div>
                                                            ))}
                                                        </>}
                                                        {!FilterTpe && <>
                                                            {formatDateAsMMDD2(date)?.map((date2, index2) => (
                                                                <div className="trNew" style={{
                                                                    color: date2?.modifiedDate ? 'green' :
                                                                        date2?.cleaningTraceabilityAddDate && date2?.cleaningTraceabilityAddDate >= convertToUnixTimestamp(currentDate) ? 'black' :
                                                                            'red'
                                                                }}>{date2?.cleaningTraceabilityItemDTO?.traceabilityName} [{date2?.traceabilityName}] ({capitalizeFirstLetter(date2?.traceabilityType)})</div>
                                                            ))}
                                                        </>
                                                        }

                                                    </>
                                                </td >
                                            </>
                                        ))}
                                    </tr>

                                    {/* {renderTableRows()} */}
                                </tbody>
                            </table>
                        </div>


                    </div>
                </Content>

                <AddNodeModel
                    visible={modalNodeModeVisible}
                    onClose={handlNodeModeCloseModal}
                    NodeModeDatas={NodeModeDatas}
                />
                {/* <FooterDashboard /> */}
            </Layout>
        </Layout >
    );
};

export default CleaningTraceability;
